import React from 'react';

import { useMutation } from '@betterment/js-runtime';

import CardLockUnlock from './CardLockUnlock';
import { useCustomer } from './CustomerProvider';

import { urlBuilder } from '../../Shared/urlBuilder';
import { Account, Card } from '../data';

interface Props {
  card: Card;
  account: Account;
}

const CardLockUnlockController: React.FC<React.PropsWithChildren<Props>> = ({ card, account }) => {
  const { refetch: loadCustomer } = useCustomer();
  const [postCardLock] = useMutation(urlBuilder.postCardLock(card.id));
  const [postCardUnlock] = useMutation(urlBuilder.postCardUnlock(card.id));

  const lockCard = async () => {
    const response = await postCardLock();
    if (response && !response.errors) {
      await loadCustomer();
    }
  };

  const unlockCard = async () => {
    const response = await postCardUnlock();
    if (response && !response.errors) {
      await loadCustomer();
    }
  };

  return <CardLockUnlock account={account} card={card} onLockCard={lockCard} onUnlockCard={unlockCard} />;
};

export default CardLockUnlockController;
